import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { Order } from '../shared/order.interface';
import { SaleI } from '../shared/sale.interface';

@Injectable({
  providedIn: 'root'
})
export class ShopService {

  constructor(private db: AngularFirestore) { }

  cargarCompras(userId: string){
    return this.db.collection('carShop/', ref => ref
                  .where('estado', '==', 'Pendiente')
                  .where('usuario', '==', userId)).snapshotChanges()
                  .pipe(
                   map(actions =>
                    actions.map(resp => {
                    const data = resp.payload.doc.data() as Order;
                    const id = resp.payload.doc.id;
                    return {id, ...data};
                    }))
                   );
   }

   deleteItemCarById(id: string, userId: string){
    return this.db.collection('carShop/', ref => ref
   .where('estado', '==', 'Pendiente')
   .where('usuario', '==', userId)).doc(id).delete();
  }

  sailProcess(compra: any){
    return this.db.collection('sales').add(compra);
  }

  saleProcessReference(userId: string, referencia: any){
    return this.db.collection('carShop/', ref => ref
                  .where('estado', '==', 'Pendiente')
                  .where('usuario', '==', userId)).snapshotChanges()
                  .pipe(
                    map(actions =>
                      actions.map(resp => {
                        const data = resp.payload.doc.data();
                        const id = resp.payload.doc.id;
                        let conIf = 0;
                        this.db.collection('carShop/').doc(id).update({
                          RefCompra: referencia
                        }).then(result => {
                            conIf++;
                           if (conIf === data['docs']['length']){
                                return(conIf);
                              }
                          });
                      }))
                  );
  }

  validateSale(referencia: number){
    return this.db.collection('sales/', ref => ref
                  .where('refCompra', '==', referencia))
                  .snapshotChanges()
                  .pipe(
                   map(actions =>
                    actions.map(resp => {
                    const data = resp.payload.doc.data() as SaleI;
                    const id = resp.payload.doc.id;
                    return {id, ...data};
                    }))
                   );
  }

  updateSaleAccepted(id: string){
    return this.db.collection('sales').doc(id).update({estado : 'Aprobada'});
  }

  pedidos(userId: string, referencia: string){
    return this.db.collection('carShop/', ref => ref
                  .where('RefCompra', '==', referencia)
                  .where('usuario', '==', userId)).snapshotChanges()
                  .pipe(
                    map(actions =>
                      actions.map(resp => {
                        const data = resp.payload.doc.data();
                        const id = resp.payload.doc.id;
                        let conIf = 0;
                        this.db.collection('carShop/').doc(id).update({
                          estado : 'Venta',
                        }).then(result => {
                            conIf++;
                            if (conIf === data['docs']['length']){
                                return(conIf);
                              }
                          });
                      }))
                  );
  }

  updateSaleRejected(id: string){
    return this.db.collection('sales').doc(id).update({estado : 'Rechazada'});
  }

  loadSalesAdmin(){
    return this.db.collection('sales', ref => ref
                  .orderBy('fecha', 'desc'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  loadSalesAdminByState(estado: any){
    return this.db.collection('sales/', ref => ref
                  .where('estado', '==', estado))
                  .snapshotChanges()
                  .pipe(
                  map(actions =>
                    actions.map(resp => {
                    const data = resp.payload.doc.data() as SaleI;
                    const id = resp.payload.doc.id;
                    return {id, ...data};
                    }))
                  );
   }

   loadSalesAdminByReference(rfce: number){
    return this.db.collection('sales/', ref => ref
                  .where('refCompra', '==', rfce))
                  .snapshotChanges()
                  .pipe(
                  map(actions =>
                    actions.map(resp => {
                    const data = resp.payload.doc.data() as SaleI;
                    const id = resp.payload.doc.id;
                    return {id, ...data};
                    }))
                  );
   }

   loadSaleByReference(compra: string){
    return this.db.collection('carShop/', ref => ref
    .where('RefCompra', '==', compra)).valueChanges();
   }

   aproveSale(idCompra: string){
    return this.db.collection('sales').doc(idCompra).update({estado: 'Aprobada'});
   }

   sendSale(idCompra: string){
    return this.db.collection('sales').doc(idCompra).update({estado: 'Despachado'});
   }

   updateSale(userId: string, referencia: string){
    return this.db.collection('sales/', ref => ref
                  .where('reference', '==', referencia)
                  .where('comprador', '==', userId)).snapshotChanges()
                  .pipe(
                   map(actions =>
                    actions.map(resp => {
                    const data = resp.payload.doc.data() as SaleI;
                    const id = resp.payload.doc.id;
                    return {id, ...data};
                    }))
                   );
  }

  pedidosCancelados(idSale: string){
    return this.db.collection('sales').doc(idSale).delete();
  }

  infoBuyerByDelivery(idBuyer: string){
    return this.db.collection('users').doc(idBuyer).valueChanges();
  }

  listClientActive(){
    return this.db.collection('users').valueChanges();
  }

  listSuscriptores(){
    return this.db.collection('subscription').valueChanges();
  }

  listMensajes(){
    return this.db.collection('mensajes').valueChanges();
  }

  cantPedidos(userId: string){
    return this.db.collection('carShop/', ref => ref
    .where('estado', '==', 'Pendiente')
    .where('usuario', '==', userId)).valueChanges();
   }

   purchasesByBuyer(id: string){
    return this.db.collection('sales/', ref => ref
    .where('idCliente', '==', id)).valueChanges();
   }

   cargarproducto(idProd: any){
    return this.db.collection('productos').doc(idProd).valueChanges();
   }
   actualizaInventario(idProd: any, nuevaCant: number){
    return this.db.collection('productos').doc(idProd).update({cantidad: nuevaCant});
   }

}
